<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Planilla Renovaciones</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
            <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
              <b-col sm="2">
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.IdNacionAse"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.NombreAseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>
           
            <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Producto</label>
              </b-col>
              <b-col sm="2">
                 <b-input-group>
                   <b-form-input type="text"  disabled v-model="datosFormulario.producto"/>
                 </b-input-group>
              </b-col>
            </b-row>

          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="generar" :disabled="disableGenerar"><i class="fa fa-file-excel-o"></i> Generar Informe</b-button>
                                <b-button variant="primary" @click="pre_insercion" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        
      </b-col>
    </b-row>  

    <b-modal
      size="lg"
      scrollable
      hide-footer
      title="Búsqueda de Contratante"
      cancel-title="Cancelar"
      v-model="modalContratante"
      @cancel="modalContratante = false"
    >
    <b-row class="my-1">
      <b-col sm="6">
        <label>Buscar:</label>
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroProceso"
            type="text"
            placeholder="Filtrar"
            v-model="filters2[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="data1"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters2"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles2"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <template slot-scope="scope">
                    <div v-if="title.prop == 'pernombreimp'">  
                        <b-link type="text" v-if="scope.row.percodigo > 0" @click="selecciona_contratante(scope.row.percodigo, scope.row.pernombreimp, scope.row.peridnacion)" >{{scope.row.pernombreimp}}</b-link>
                        <p v-else >{{scope.row.pernombreimp}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
              
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiBaseDatosResoluc from "@/components/services/apiBaseDatosResoluc";
import apiPlanRenovaciones from "@/components/services/apiPlanRenovaciones";
import apiConCorredor  from "@/components/services/apiConCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import XLSX from "xlsx";

export default {
  name: "PlanillaRenovaciones",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {  
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      modalContratante : false,
      selectedCor: [],
      selectedDire:[],
      disableGenerar:false,
      data_condiciones: [],
      data_ventas_antepenult: [],
      data_ventas_penult: [],
      data_ventas_ult: [],
      data_produccion: [],
      data_lineas : [],
      data_sinihist : [],
      data_siniultvig : [],
      data_tasatecnica : [],
      data_res_siniimpa : [],
      data1: [],
      data2: [],
      
      titles2: [
        {
          prop: "pernombreimp",
          label: "Contratante",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "percodigo",
          label: "Código",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "peridnacion",
          label: "Id Nacional",
          align: "center",
          minwidth:'100'
        },
      ],

      titles3: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "codcorredor",
          label: "Código",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "idnacion",
          label: "Id. Nacional",
          align: "center",
          minwidth:'120'
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filters2: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filters3: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      mostrarFechas: true,
      datosFormulario: {
          poliza:"",
          producto:"",
          contratante:"",
          IdNacionAse :"",
          NombreAseg:"",
          IdNacionCorred:"",
          NombreCorred:""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      productos: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificarContacto(row);
          }
          botones.push(obj);
          
          return botones;
    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();

          } else {
              sums[index] = '';
          }
      });

      return sums;
    },
    
    async exportarExcel() {
    const wb = new ExcelJS.Workbook();

      // =========================
      // ESTILOS CENTRALIZADOS
      // =========================
    const ExcelEngine = (() => {

    const styles = {
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      },

    headerFill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9D9D9" }
    }
    };

    const applyHeader = (ws) => {
    ws.getRow(1).eachCell(cell => {
      cell.font = { bold: true };
      cell.fill = styles.headerFill;
      cell.border = styles.border;
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    });
    };

    const applyFullBorder = (row, totalCols) => {
    for (let i = 1; i <= totalCols; i++) {
      row.getCell(i).border = styles.border;
    }
    };

    const formatNumber = (cell, decimals = true) => {
    cell.numFmt = decimals ? "#,##0.00" : "#,##0";
    cell.alignment = { horizontal: "right" };
    };

    const formatPercent = (cell, decimals = true) => {
    cell.numFmt = decimals ? "0.00%" : "0%";
    cell.alignment = { horizontal: "right" };
    };

    const applyTotalRow = (row) => {
    row.eachCell(cell => {
      cell.font = { bold: true };
    });
    };

    const addTextRow = (ws, label, value, bold = false, center = false) => {
    const row = ws.addRow([label, value || ""]);

    if (bold) row.getCell(1).font = { bold: true };

    row.getCell(2).alignment = {
      horizontal: center ? "center" : "right",
      vertical: "middle"
    };

    applyFullBorder(row, 2);
    };

    const addSection = (ws, title) => {
    const row = ws.addRow([title, ""]);

    ws.mergeCells(`A${row.number}:B${row.number}`);

    row.getCell(1).fill = styles.headerFill;
    row.getCell(1).font = { bold: true, size: 9 };
    row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
    row.getCell(1).border = styles.border;
    };

  return {
    styles,
    applyHeader,
    applyFullBorder,
    formatNumber,
    formatPercent,
    applyTotalRow,
    addTextRow,
    addSection
  };

})();

// =========================
// HOJA CONDICIONES
// =========================     
  const createCondicionesSheet = () => {

    const ws = wb.addWorksheet("Condiciones", {
    properties: {},
    pageSetup: {},
    views: [],
    state: 'visible',
    headerFooter: {},
    defaultRowHeight: 12,
    });

    const FONT_SIZE = 9;

   const c = (this.data_condiciones || [])[0];

  if (!c) return;

  ws.columns = [{ width: 35 }, { width: 45 }];

   const applyBorderCondiciones = (row) => {
  row.eachCell(cell => {
    cell.border = ExcelEngine.styles.border;

    cell.alignment = {
      ...(cell.alignment || {}),
      vertical: "middle",
      wrapText: true
    };

    cell.font = {
      ...(cell.font || {}),
      size: FONT_SIZE
    };
  });
};

 const hasDecimals = (value) => {
   return Math.floor(value) !== value;
   };

    // =========================
    // MAPA DE FORMATOS
    // =========================
  const formatMap = {
      pcrmonasegproy: { type: "currency", monedaField: "marmoneda" },
      pcrcorteinndesde: { type: "currency", monedaField: "marmoneda" },
      pcrcorteinn: { type: "currency", monedaField: "marmoneda" }, 
      pcrumbral: { type: "currency", monedaField: "marmoneda" },
      pcrcostpeligsini: { type: "currency", monedaField: "marmoneda" },
      costovarmin: { type: "currency", monedaField: "marmoneda" },
      tsilineamayor: { type: "currency", monedaField: "marmoneda" },

      tasa: { type: "number" },
      tasapr: { type: "number" },

      cobnom: { type: "percent" },
      cobinn: { type: "percent" },
      porcaprlineas: { type: "percent" },

      tsisiniacu: { type: "percent" },
      tsisiniinn: { type: "percent" },
      tsisiniult: { type: "percent" },
      tsisinipult: { type: "percent" },

      lneplazo: { type: "integer" },
      lneplaznom: { type: "integer" },
      lneplazinn: { type: "integer" },
      pcrplazfacpol: { type: "integer" },
      pcrplazlibpol: { type: "integer" },
      pcrplazlibnom: { type: "integer" },
      pcrplazlibinn: { type: "integer" },
      tsinomactivos: { type: "integer" },
      tsiinnactivos: { type: "integer" }
    };

  const parsePercent = (value) => {
    if (value === null || value === undefined) return null;

    const num = Number(
      String(value).replace(",", ".")
    );

    return isNaN(num) ? null : num / 100;
  };

  const addRow = (label, field, data, centerValue = false, boldLabel = false) => {
    let value = field ? data && data[field] : "";

    const config = formatMap[field] || { type: "text" };

    // =========================
    // SAFE VALUE
    // =========================
  const safeValue = (v) => {
      return (v !== null && v !== undefined) ? v : "";
    };

    // =========================
    // NORMALIZADOR DE NÚMEROS
    // =========================
  const normalizeNumber = (value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === "number") return value;

      const cleaned = String(value)
        .replace(/\./g, "")
        .replace(",", ".");

      const num = Number(cleaned);
      return isNaN(num) ? null : num;
    };

    value = normalizeNumber(value);

  const isNumber = typeof value === "number" && !isNaN(value);

    // =========================
    // CREAR FILA
    // =========================
    const row = ws.addRow([
      label,
      isNumber ? value : safeValue(data && data[field])
    ]);

    // =========================
    // LABEL STYLE
    // =========================
    if (boldLabel) {
      row.getCell(1).font = { bold: true };
    }

    const cell = row.getCell(2);

    if (!cell) return;

    // =========================
    // FORMATO NUMÉRICO
    // =========================
    if (isNumber) {
      switch (config.type) {

      case "currency": {
          const moneda = data && data[config.monedaField] || "$";

          const hasDecimals = value % 1 !== 0;

          cell.numFmt = hasDecimals
            ? `"${moneda}" #,##0.00`
            : `"${moneda}" #,##0`;

          break;
        }

        case "number":
          cell.numFmt = "#,##0.00";
          break;

        case "integer":
          cell.numFmt = "#,##0";
          break;

      case "percent":
        value = parsePercent(data && data[field]);

        if (!hasDecimals(value * 100)) {
          // sin decimales
          cell.value = value;
          cell.numFmt = "0%";
          break;
        }

        // con decimales
        cell.value = value;
        cell.numFmt = "0.00%";
        break;
      }
    }

    // ===========
    // ALINEACIÓN 
    // ===========
    cell.alignment = {
      ...(cell.alignment || {}),
      horizontal: centerValue ? "center" : "right",
      vertical: "middle"
    };

    // =========================
    // BORDES
    // =========================
    applyBorderCondiciones(row);
  };

    const addTextRow = (label, value, boldLabel = false, centerValue = false) => {
    const row = ws.addRow([label, value || ""]);

    // Negrita solo si se pide
    if (boldLabel) {
      row.getCell(1).font = { bold: true };
    }

    // Centrado opcional
    if (centerValue) {
      row.getCell(2).alignment = { horizontal: "center" };
    }

    applyBorderCondiciones(row);
  };

  // =========================
  // SECTION
  // =========================
    const addSection = (title) => {
      const row = ws.addRow([title, ""]);

      ws.mergeCells(`A${row.number}:B${row.number}`);

      row.getCell(1).fill = ExcelEngine.styles.headerFill;

      row.getCell(1).font = {
        bold: true,
        size: 9
      };

      row.getCell(1).alignment = {
        horizontal: "center",
        vertical: "middle"
      };

      row.getCell(1).border = ExcelEngine.styles.border;
    };

  // =========================
  // CABECERA
  // =========================
    addTextRow("Contratante", c.nombre_contratante, true, true);

    const row = ws.lastRow;
         row.getCell(2).font = {
     ...(row.getCell(2).font || {}),
     bold: true
    };

    addTextRow("Corredor", c.nombre_corredor, true, true);
    addTextRow("Asegurado desde", c.vigdesdepo, true, true);
    addTextRow("Producto", c.marproducto, true, true);
    addTextRow("Moneda Póliza", c.marmoneda, true, true);
    addTextRow("Ejecutivo", c.cliejecutivo, true, true);
    addTextRow("Asistente", c.cliasistente, true, true);
    addTextRow("Póliza", c.marpoliza, true, true);
    addTextRow("Comité de Siniestralidad", "", true, true);

    ws.addRow([]);

    const item = ws.addRow([
      "ITEM",
      `${c.vigdesde || ""} - ${c.vighasta || ""}`
    ]);

    item.eachCell(cell => {
      cell.fill = ExcelEngine.styles.headerFill;

      cell.font = {
        ...(cell.font || {}),
        bold: true,
        size: 9
      };

      cell.border = ExcelEngine.styles.border;

      cell.alignment = {
        ...(cell.alignment || {}),
        horizontal: "center",
        vertical: "middle"
      };
    });

  // =========================
  // DATOS PRINCIPALES
  // =========================
  addRow("Monto Asegurado Proyectado", "pcrmonasegproy", c, true);
  addTextRow("Materia Asegurada", c.materiaaseg, false, true);
  addTextRow("Pólizas relacionadas", "", false, true);
  addTextRow("Monto Asegurado Pólizas relacionadas", "", false, true);

  // =========================
  // SINIESTRALIDAD
  // =========================
  addSection("SINIESTRALIDAD");
  addRow("Siniestralidad Acumulada", "tsisiniacu", c, true);
  addRow("Siniestralidad Acumulada Innominados", "tsisiniinn", c, true);
  addRow("Siniestralidad Última Vigencia", "tsisiniult", c, true);
  addRow("Siniestralidad Penúltima Vigencia", "tsisinipult", c, true);
  addTextRow("Siniestralidad de Grupo", "", false, true);

  // =========================
  // CONDICIONES
  // =========================
  addSection("CONDICIONES PARTICULARES");
  addRow("Plazo máximo de venta Póliza", "lneplazo", c, true);
  addRow("Plazo máximo de venta Nominados", "lneplaznom", c, true);
  addRow("Plazo máximo de venta Innominados", "lneplazinn", c, true);
  addRow("Porcentaje de Cobertura Nominados", "cobnom", c, true);
  addRow("Porcentaje de Cobertura Innominados", "cobinn", c, true);
  addRow("Innominados Desde", "pcrcorteinndesde", c, true);
  addRow("Innominados Hasta", "pcrcorteinn", c, true);
  addRow("Tipo de SAAL", "pcrtiposaal", c, true);
  addTextRow("Antigüedad, experiencias de pago favorables y pérdida de la antigüedad", "", false, true);
  addRow("Umbral", "pcrumbral", c, true);
  addRow("Costo del Seguro", "lnelinneg", c, true);
  addRow("Costo de Estudio Nominados", "pcrmontocostest", c, true);
  addRow("Costo de Estudio Innominados", "pcrcostomenores", c, true);
  addRow("Costo Mantención Nominados y Periodicidad de Cobro", "pcrcostorenov", c, true);
  addRow("Costo Mantención Innominados y Periodicidad de Cobro", "pcrcostrenovinn", c, true);
  addRow("Costo de Prórroga", "lnetasaprorro", c, true);
  addRow("Costo de Peligro de Siniestro", "pcrcostpeligsini", c, true);
  addRow("Prórroga / Plazo Libre Póliza", "pcrplazfacpol", c, true);
  addRow("Prórroga / Plazo Libre Nominados", "pcrplazfacnom", c, true);
  addRow("Prórroga / Plazo Libre Innominados", "pcrplazfacinn", c, true);
  addRow("Costo Variable Mínimo - Periodicidad", "pcrprimaminima", c, true);
  addRow("Prima de Depósito", "facturadv", c, true);
  addRow("Indemnización Máxima Póliza", "pcrindemaxnom", c, true);
  addRow("Indemnización Máxima Innominados", "pcrindemaxinn", c, true);
  addRow("Indemnización Máxima Nominados", "pcrindemnom", c, true);

  // =========================
  // CLAUSULAS ESPECIALES
  // =========================
  addSection("CLÁUSULAS ESPECIALES");
  addTextRow("Cobertura Automática Primera Venta", "", false, true);
  addRow("Profit/Periodo", "profit", c, true);
  addRow("Malus/Periodo", "malus", c, true); 
  addRow("Alza/Baja de Tasa", "abtasa", c, true);
  addTextRow("Estacionalidad de Ventas", "", false, true);
  addTextRow("Reducción o Cancelación Límite de Crédito", "", false, true);
  addTextRow("Aprobación de Límite de Crédito Parcial", "", false, true);
  addRow("CAD Terremoto", "gadnombre", c, true);
  addRow("Día Declaración de Ventas", "pcrdiadecla", c, true);
  addTextRow("Error en Declaración de Ventas", "", false, true); 

  // =========================
  // LÍNEAS
  // =========================
  addSection("LÍNEAS");

  addRow("Línea mayor", "tsinomlinmay", c, true);
  addRow("Monto", "tsilineamayor", c, true);
  addRow("Nominados Activos", "tsinomactivos", c, true);
  addRow("Innominados Activos", "tsiinnactivos", c, true);
  addRow("Porcentaje de Aprobación", "porcaprlineas", c, true);
};

// =========================
// HOJA VENTAS
// =========================
const createVentasSheet = () => {

  const ws = wb.addWorksheet("Ventas");

  // =========================================
  // DATA
  // =========================================
  const dataAntePenultima = this.data_ventas_antepenult || [];
  const dataPenultima = this.data_ventas_penult || [];
  const dataUltima = this.data_ventas_ult || [];

  // =========================================
  // COLUMNAS
  // =========================================
  ws.columns = [
  { key: "endoso", width: 18 },
  { key: "periodo", width: 15 },
  { key: "moneda", width: 15 },
  { key: "ventas", width: 25 },
  { key: "prima", width: 25 },
  { key: "pagador", width: 35 }
];

  // =========================================
  // FUNCION PARA CREAR BLOQUE
  // =========================================
  const drawSection = (titulo, data) => {

    // =========================
    // TITULO
    // =========================
    const titleRow = ws.addRow([titulo]);

    titleRow.font = { bold: true };

    // =========================
    // HEADER
    // =========================
    const headerRow = ws.addRow([
      "Endoso",
      "Mes-Año",
      "Moneda Póliza",
      "Ventas Declaradas",
      "Prima",
      "Pagador"
    ]);

    headerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle"
      };
    });

    // =========================
    // DETALLE
    // =========================
    let totalVentas = 0;
    let totalPrima = 0;

    data.forEach(v => {

      const ventas = Number(v.monto || 0);
      const prima = Number(v.primasus || 0);

      totalVentas += ventas;
      totalPrima += prima;

      const row = ws.addRow({
        endoso: v.marendoso,
        periodo: v.venanomes,
        moneda: v.marmoneda,
        ventas,
        prima,
        pagador: v.pagador
      });

      // formato numérico
      row.getCell(4).numFmt = '0.00';//'#,##0.00';
      row.getCell(5).numFmt = '0.00';//'#,##0.00';

    });

    // =========================
    // TOTAL
    // =========================
    const moneda = data.length
      ? data[0].marmoneda
      : "";

    const totalRow = ws.addRow([
      "",
      "",
      "",
      totalVentas,
      totalPrima,
      ""
    ]);

    totalRow.getCell(4).value = totalVentas;
    totalRow.getCell(5).value = totalPrima;

    totalRow.getCell(4).numFmt =
      `"Total (${moneda}): " #,##0.00`;

    totalRow.getCell(5).numFmt =
      `"Total (${moneda}): " #,##0.00`;

    totalRow.font = { bold: true };

    // espacio entre bloques
    ws.addRow([]);

  };

  // =========================================
  // ANTEPENÚLTIMA ANUALIDAD
  // =========================================
  drawSection(
    "Antepenúltima Anualidad",
    dataAntePenultima
  );

  // =========================================
  // PENÚLTIMA ANUALIDAD
  // =========================================
  drawSection(
    "Penúltima Anualidad",
    dataPenultima
  );

  // =========================================
  // ÚLTIMA ANUALIDAD
  // =========================================
  drawSection(
    "Última Anualidad",
    dataUltima
  );

};

// =========================
// HOJA PRODUCCION
// =========================
const createProduccionSheet = () => {

  const data = this.data_produccion || [];

  const ws = wb.addWorksheet("Producción");

  ws.columns = [
    { header: "Prod", key: "prod", width: 10 },
    { header: "Póliza", key: "poliza", width: 10 },
    { header: "Doc", key: "doc", width: 10 },
    { header: "Acc", key: "acc", width: 10 },
    { header: "Endoso", key: "endoso", width: 10 },
    { header: "Tipo", key: "tipo", width: 10 },
    { header: "Fecha Emisión", key: "femis", width: 15 },
    { header: "Fecha Ventas", key: "fvtas", width: 15 },
    { header: "Prima", key: "prima", width: 18 },
    { header: "Costo", key: "costo", width: 18 },
    { header: "Monto Ventas", key: "mtoventas", width: 18 },
    { header: "Nombre Asegurado", key: "asegurado", width: 22 }
  ];

  // =========================
  // FORMATO DEL ENCABEZADO
  // =========================
  const header = ws.getRow(1);

  header.font = {
    bold: true
  };

  header.alignment = {
  horizontal: "center",
  vertical: "middle"
  }; 

  const formatDate = (v) => {
    if (!v) return "";

    const value = String(v);

    if (value.length >= 10) {
      return `${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)}`;
    }

    return value;
  };

  // Agregar directamente a ExcelJS
  data.forEach(d => {

    ws.addRow({
      prod: d.prod,
      poliza: d.poliza,
      doc: d.doc,
      acc: d.acc,
      endoso: d.endoso,
      tipo: d.tipo,
      femis: formatDate(d.femis),
      fvtas: d.fvtas,
      prima: d.prima,
      costo: d.costo,
      mtoventas: d.mtoventas,
      asegurado: d.asegurado
    });

  });

  // Formatos numéricos
  ws.getColumn("prima").numFmt = '0.00;-0.00;0';
  ws.getColumn("costo").numFmt = '0.00;-0.00;0';
  ws.getColumn("mtoventas").numFmt = '0.00;-0.00;0';

};

// =========================
// HOJA LINEAS
// =========================  
const createLineasSheet = () => {

  const data = this.data_lineas || [];
  if (!data.length) return;

  const ws = wb.addWorksheet("Líneas");

  let totalMtoSol = 0;
  let totalMtoApr = 0;

  const parseNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;

    return Number(
      String(v)
        .replace(/\./g, "")
        .replace(",", ".")
    ) || 0;
  };

  // =========================
  // COLUMNAS 
  // =========================
  ws.columns = [
    { header: "Id. Nacional", key: "idnacion", width: 18 },
    { header: "Nro. SR", key: "sujriesgo", width: 12 },
    { header: "Cliente", key: "cliente", width: 40 },
    { header: "Clasificación", key: "clasif", width: 15 },
    { header: "Moneda Cúmulo", key: "moncumulo", width: 18 },
    { header: "Cúmulo", key: "cumulo", width: 18 },
    { header: "Estado Cliente", key: "cliestado", width: 18 },
    { header: "País", key: "pais", width: 15 },
    { header: "Vigencia Desde", key: "vigdesde", width: 15 },
    { header: "Vigencia Hasta", key: "vighasta", width: 18 },
    { header: "Moneda Póliza", key: "moneda", width: 18 },
    { header: "Monto Solicitado", key: "mtosol", width: 18 },
    { header: "Monto Aprobado", key: "mtoapr", width: 18 },
    { header: "% Individual", key: "porcind", width: 15 },
    { header: "Estado", key: "estado", width: 15 },
    { header: "Uso", key: "uso", width: 18 },
    { header: "Condición de Venta", key: "condventa", width: 40 },
    { header: "Matríz / Sublínea", key: "matrizsub", width: 20 },
    { header: "Línea de Negocios", key: "linneg", width: 18 },
    { header: "Plazo (días)", key: "plazo", width: 15 },
    { header: "Observaciones", key: "observ", width: 35 }
  ];

  // =========================
  // HEADER
  // =========================
  const headerRow = ws.getRow(1);

  headerRow.font = { bold: true };
  headerRow.alignment = {
    horizontal: "center",
    vertical: "middle",
    wrapText: true
  };

  // =========================
  // DATA
  // =========================
  data.forEach(d => {

    const mtosol = parseNumber(d.mtosol);
    const mtoapr = parseNumber(d.mtoapr);

    totalMtoSol += mtosol;
    totalMtoApr += mtoapr;

    ws.addRow({
      idnacion: d.idnacion,
      sujriesgo: String(d.sujriesgo),
      cliente: d.cliente,
      clasif: d.clasif,
      moncumulo: d.moncumulo,
      cumulo: parseNumber(d.cumulo),
      cliestado: d.cliestado,
      pais: d.pais,
      vigdesde: d.vigdesde,
      vighasta: d.vighasta,
      moneda: d.moneda,
      mtosol,
      mtoapr,
      porcind: mtosol ? (mtoapr / mtosol) : 0,
      estado: d.estado,
      uso: d.uso,
      condventa: d.condventa,
      matrizsub: d.matrizsub,
      linneg: d.linneg,
      plazo: d.plazo,
      observ: d.observ
    });
  });

  // =========================
  // FORMATO 
  // =========================
  ws.getColumn(6).numFmt = '0';   // cúmulo
  ws.getColumn(12).numFmt = '0';  // mtosol
  ws.getColumn(13).numFmt = '0';  // mtoapr
  ws.getColumn(14).numFmt = '0%'; // porcentaje sin decimales

  // =========================
  // TOTAL
  // =========================
  const porcentajeTotal =
    totalMtoSol > 0 ? totalMtoApr / totalMtoSol : 0;

  const totalRow = ws.addRow({
    idnacion: "Total",
    mtosol: totalMtoSol,
    mtoapr: totalMtoApr,
    porcind: porcentajeTotal
  });

  totalRow.font = { bold: true };

  totalRow.getCell(12).numFmt = '0';
  totalRow.getCell(13).numFmt = '0';
  totalRow.getCell(14).numFmt = '0%';

};

// =========================
// HOJA SINIESTRALIDAD
// =========================
const createSiniestralidadSheet = () => {
  const wbSheet = wb.addWorksheet("Siniestralidad");

  // =====================================================
  // COLUMNAS
  // =====================================================
  wbSheet.columns = [
    { key: "ramo", width: 10 },
    { key: "asegurado", width: 35 },
    { key: "poliza", width: 18 },
    { key: "mes", width: 14 },
    { key: "suscrita", width: 16 },
    { key: "ganada", width: 16 },
    { key: "pagos", width: 14 },
    { key: "gastos", width: 14 },
    { key: "recupero", width: 14 },
    { key: "prov", width: 16 },
    { key: "sin", width: 16 }
  ];

  // formatos por columna
  [5, 6, 7, 8, 9, 10].forEach(col => {
    wbSheet.getColumn(col).numFmt = "0.00";
  });

  wbSheet.getColumn(11).numFmt = "0.00%";
  let rowIndex = 1;

  const toNumber = (value) => Number(value || 0);

  const toPercent = (value) => {
        const num = Number(
         String(value == null ? 0 : value).replace(",", ".")
        );

    return isNaN(num) ? 0 : num / 100;
  };

  // =====================================================
  // HEADER
  // =====================================================
  const insertTableHeader = () => {

    const row = wbSheet.insertRow(rowIndex++, [
      "Ramo",
      "Contratante",
      "Póliza",
      "Año/Mes",
      "Prima Suscrita",
      "Prima Ganada",
      "Pagos",
      "Gastos",
      "Recuperos",
      "Provisiones",
      "Siniestralidad"
    ]);

    row.height = 22;

    row.eachCell(cell => {

      cell.font = { bold: true };

      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true
      };
    });

    return row;
  };

  // =====================================================
  // DETALLE
  // =====================================================
  const insertDetailRow = (d) => {

    const row = wbSheet.insertRow(rowIndex++, {
      ramo: d.ramo || "",
      asegurado: d.asegurado || "",
      poliza: d.poliza || "",
      mes: d.mes || "",
      suscrita: toNumber(d.suscrita),
      ganada: toNumber(d.ganada),
      pagos: toNumber(d.pagos),
      gastos: toNumber(d.gastos),
      recupero: toNumber(d.recupero),
      prov: toNumber(d.prov),
      sin: toPercent(d.siniestralidad)
    });

    return row;
  };

  // =====================================================
  // SUBTOTAL
  // =====================================================
  const insertSubtotalRow = (label, totals) => {

    const siniestralidad =
      totals.ganada !== 0
        ? (
            (
              totals.pagos +
              totals.gastos +
              totals.recupero +
              totals.prov
            ) / totals.ganada
          )
        : 0;

    const row = wbSheet.insertRow(rowIndex++, [
      "",
      "",
      "",
      label,
      totals.suscrita,
      totals.ganada,
      totals.pagos,
      totals.gastos,
      totals.recupero,
      totals.prov,
      siniestralidad
    ]);

    row.eachCell(cell => {
      cell.font = { bold: true };
    });

    return row;
  };

  // =====================================================
  // TITULO
  // =====================================================
  const insertTitle = (title) => {

    const row = wbSheet.insertRow(rowIndex++, [title]);

    wbSheet.mergeCells(`A${row.number}:K${row.number}`);

    row.eachCell(cell => {

      cell.font = {
        bold: true,
        size: 12
      };

      cell.alignment = {
        horizontal: "left",
        vertical: "middle"
      };
    });

    return row;
  };

  // =====================================================
  // SINIESTRALIDAD HISTÓRICA
  // =====================================================
  insertTitle("Siniestralidad Histórica");

  insertTableHeader();

  const hist = this.data_sinihist || [];

  const grupos = {};

  hist.forEach(item => {

    const ramo = item.ramo || "SIN RAMO";

    if (!grupos[ramo]) {
      grupos[ramo] = [];
    }

    grupos[ramo].push(item);
  });

  Object.keys(grupos)
  .sort((a, b) => {

    const orden = {
      "D": 1,
      "D Inn.": 2
    };

    return (orden[a] || 99) - (orden[b] || 99);
  })
  .forEach(ramo => {

    const items = grupos[ramo];

    const totals = {
      suscrita: 0,
      ganada: 0,
      pagos: 0,
      gastos: 0,
      recupero: 0,
      prov: 0
    };

    items.forEach(d => {

      insertDetailRow(d);

      totals.suscrita += toNumber(d.suscrita);
      totals.ganada += toNumber(d.ganada);
      totals.pagos += toNumber(d.pagos);
      totals.gastos += toNumber(d.gastos);
      totals.recupero += toNumber(d.recupero);
      totals.prov += toNumber(d.prov);
    });

    let subtotalLabel = `Total ${ramo}`;

    if (ramo === "D" || ramo === "E") {
      subtotalLabel = "Total Nominados";
    }

    if (ramo === "D Inn." || ramo === "E Inn.") {
      subtotalLabel = "Total Innominados";
    }

    insertSubtotalRow(subtotalLabel, totals);
  });

  // =====================================================
  // TOTAL HISTÓRICO
  // =====================================================
  const histTotal = this.data_sinihisttot || [];

  const totalHistorico = {
    suscrita: 0,
    ganada: 0,
    pagos: 0,
    gastos: 0,
    recupero: 0,
    prov: 0
  };

  const ramosUnicos = [...new Set(hist.map(x => x.ramo || "SIN RAMO"))];

  if (ramosUnicos.length > 1) {

      histTotal.forEach(d => {

        insertDetailRow({
          ...d,
          ramo: "Total"
        });

        totalHistorico.suscrita += toNumber(d.suscrita);
        totalHistorico.ganada += toNumber(d.ganada);
        totalHistorico.pagos += toNumber(d.pagos);
        totalHistorico.gastos += toNumber(d.gastos);
        totalHistorico.recupero += toNumber(d.recupero);
        totalHistorico.prov += toNumber(d.prov);
      });
  } else {

  // Si sólo hay un ramo, no duplicar fila
  histTotal.forEach(d => {

    totalHistorico.suscrita += toNumber(d.suscrita);
    totalHistorico.ganada += toNumber(d.ganada);
    totalHistorico.pagos += toNumber(d.pagos);
    totalHistorico.gastos += toNumber(d.gastos);
    totalHistorico.recupero += toNumber(d.recupero);
    totalHistorico.prov += toNumber(d.prov);
  });
}
  if (ramosUnicos.length > 1) {  
    insertSubtotalRow(
      "Total Siniestralidad",
      totalHistorico
    );
  }

  // =====================================================
  // ESPACIO
  // =====================================================
  wbSheet.insertRow(rowIndex++, []);

// =====================================================
// ÚLTIMA VIGENCIA
// =====================================================
insertTitle("Siniestralidad Última Vigencia");

insertTableHeader();

const ult = (this.data_siniultvig || []).sort((a, b) => {
  const normalize = (ramo) => {
    const isInn = ramo.includes("Inn.");
    const base = ramo.replace(" Inn.", "");
    return {
      base,
      innOrder: isInn ? 1 : 0
    };
  };

  const ra = normalize(a.ramo || "");
  const rb = normalize(b.ramo || "");

  if (ra.base < rb.base) return -1;
  if (ra.base > rb.base) return 1;

  return ra.innOrder - rb.innOrder;
});

const totalUltima = {
  suscrita: 0,
  ganada: 0,
  pagos: 0,
  gastos: 0,
  recupero: 0,
  prov: 0
};

ult.forEach(d => {

  insertDetailRow(d);

  totalUltima.suscrita += toNumber(d.suscrita);
  totalUltima.ganada += toNumber(d.ganada);
  totalUltima.pagos += toNumber(d.pagos);
  totalUltima.gastos += toNumber(d.gastos);
  totalUltima.recupero += toNumber(d.recupero);
  totalUltima.prov += toNumber(d.prov);
});

insertSubtotalRow(
  "Total",
  totalUltima
);

};

// =========================
// HOJA TASA TECNICA
// =========================
const createTasaTecnicaSheet = () => {
  const data = this.data_tasatecnica || [];

  const ws = wb.addWorksheet("Tasa Técnica");

  const columns = [
    { header: "Ramo", key: "ramo", width: 8 },
    { header: "Código", key: "codigo", width: 10 },
    { header: "Asegurado", key: "asegurado", width: 35 },
    { header: "Póliza", key: "poliza", width: 15 },
    { header: "Mes", key: "mes", width: 12 },
    { header: "Suscrita", key: "sus", width: 15 },
    { header: "Ganada", key: "gan", width: 15 },
    { header: "Pagos", key: "pagos", width: 15 },
    { header: "Gastos", key: "gastos", width: 15 },
    { header: "Recupero", key: "rec", width: 15 },
    { header: "Prov", key: "prov", width: 15 },
    { header: "Siniestralidad", key: "sin", width: 15 }
  ];

  ws.columns = columns;

  // =====================================================
  // HEADER 
  // =====================================================
  ws.getRow(1).eachCell(cell => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = undefined; // sin bordes
    cell.fill = undefined;   // sin relleno
  });

  let sum = {
    sus: 0, gan: 0, pagos: 0, gastos: 0, rec: 0, prov: 0
  };

  const parse = v => Number(v || 0);

  // =====================================================
  // PRIMERA TABLA 
  // =====================================================
  data.forEach(d => {
    const row = ws.addRow({
      ramo: d.ramo,
      codigo: d.codigo,
      asegurado: d.asegurado,
      poliza: d.poliza,
      mes: d.mes,
      sus: parse(d.suscrita),
      gan: parse(d.ganada),
      pagos: parse(d.pagos),
      gastos: parse(d.gastos),
      rec: parse(d.recupero),
      prov: parse(d.prov),
      sin: parse(d.siniestralidad) / 100
    });

    ["sus","gan","pagos","gastos","rec","prov"].forEach(k => {
      row.getCell(k).numFmt = "0.00";
      row.getCell(k).alignment = { horizontal: "right" };
    });
    
    row.getCell("sin").numFmt = "0.00%";
    row.getCell("sin").alignment = { horizontal: "right" };

    sum.sus += parse(d.suscrita);
    sum.gan += parse(d.ganada);
    sum.pagos += parse(d.pagos);
    sum.gastos += parse(d.gastos);
    sum.rec += parse(d.recupero);
    sum.prov += parse(d.prov);
  });

  const sinTotal =
  sum.gan > 0
    ? (sum.pagos + sum.gastos + sum.rec + sum.prov) / sum.gan
    : 0;

  // =====================================================
  // TOTAL PRIMERA TABLA 
  // =====================================================
 const totalRow = ws.addRow({
  mes: "Total",
  sus: sum.sus,
  gan: sum.gan,
  pagos: sum.pagos,
  gastos: sum.gastos,
  rec: sum.rec,
  prov: sum.prov,
  sin: sinTotal
});

// SOLO NEGRITA 
totalRow.eachCell(cell => {
  cell.font = {
    ...(cell.font || {}),
    bold: true
  };

totalRow.getCell("sin").numFmt = "0.00%";
totalRow.getCell("sin").alignment = { horizontal: "right" };  
});
// =====================================================
// CÁLCULOS
// =====================================================


// const costoSiniestroTotal =
//   sum.pagos + sum.gastos + sum.rec + sum.prov;

//const costoSiniestroAnual = costoSiniestroTotal / 4;

const condiciones = (this.data_condiciones || [])[0] || {};

const costoSiniestroTotal =
  sum.pagos + sum.gastos + sum.rec + sum.prov;

// Fecha de inicio PO: dd/mm/yyyy
const fechaInicioPO = condiciones.vigdesdepo;

console.log('fechaInicioPO', fechaInicioPO);

// Obtener el mayor mes de cierre desde la columna Mes (YYYY/MM)
const meses = data
  .map(d => String(d.mes || "").trim())
  .filter(m => /^\d{4}\/\d{2}$/.test(m))
  .sort();

const ultimoMes = meses.length > 0
  ? meses[meses.length - 1]
  : null;

console.log('ultimoMes',ultimoMes);

let mesesVigencia = 48; // Máximo de 4 años

if (fechaInicioPO && ultimoMes) {
  const partesInicio = fechaInicioPO.split("/");
  const partesCierre = ultimoMes.split("/");

  if (partesInicio.length === 3) {
    // Sólo se consideran mes y año de inicio
    const anioInicio = Number(partesInicio[2]);
    const mesInicio = Number(partesInicio[1]);

    // El cierre ya viene en formato YYYY/MM
    const anioCierre = Number(partesCierre[0]);
    const mesCierre = Number(partesCierre[1]);

    console.log('anioInicio', anioInicio);
    console.log('mesInicio', mesInicio);
    console.log('anioCierre', anioCierre);
    console.log('mesCierre', mesCierre);

    const diferenciaMeses =
      (anioCierre - anioInicio) * 12 +
      (mesCierre - mesInicio) + 1;  

      console.log('diferenciaMeses', diferenciaMeses);

    mesesVigencia = Math.min(
      48,
      Math.max(0, diferenciaMeses)
    );
    console.log('mesesVigencia', mesesVigencia);
  }
}

// Convertir meses a años
const aniosVigencia = Number((mesesVigencia / 12).toFixed(2));

console.log('aniosVigencia', aniosVigencia);

// Costo de siniestro anual según vigencia
const costoSiniestroAnual =
  aniosVigencia > 0
    ? costoSiniestroTotal / aniosVigencia
    : 0;

const maProyectado = Number(
  String(condiciones.pcrmonasegproy || 0)
    .replace(/\./g, "")
    .replace(",", ".")
);

const tasaSiniestro =
  maProyectado > 0
    ? costoSiniestroAnual / maProyectado
    : 0;

const prima = tasaSiniestro * maProyectado;

const prima60 = prima / 0.6;

const tasaTecnica =
  maProyectado > 0
    ? prima60 / maProyectado
    : 0;

// espacio
const startRow = ws.lastRow.number + 3;

const colStart = 5;
const colEnd = 8;

// =====================================================
// SEGUNDA TABLA
// =====================================================
const createRow = (
  rowIndex,
  label,
  value,
  type = "number" 
) => {

  // columna nombre
  const labelCell = ws.getCell(rowIndex, colStart);
  labelCell.value = label;
  labelCell.font = { bold: true };
  labelCell.alignment = { horizontal: "left" };

  // columna valor
  const valueCell = ws.getCell(rowIndex, colStart + 1);

  valueCell.value = Number(value);
  valueCell.alignment = { horizontal: "right" };

  // formatos Excel
  if (type === "percent") {
    valueCell.numFmt = "0.00%";
  } else {
    valueCell.numFmt = "#,##0.00";
  }

  ws.getColumn(colStart).width = 26;
  ws.getColumn(colStart + 1).width = 20;

  // bordes
  for (let c = colStart; c <= colStart + 1; c++) {
    ws.getRow(rowIndex).getCell(c).border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" }
    };
  }
};

// bloque 1
createRow(startRow,     "Costo Siniestro Total", costoSiniestroTotal);
createRow(startRow + 1, "Costo Siniestro Anual", costoSiniestroAnual);
createRow(startRow + 2, "Tasa Siniestro", tasaSiniestro, "percent");
createRow(startRow + 3, "MA Proyectado", maProyectado);
createRow(startRow + 4, "Prima", prima);
createRow(startRow + 5, "Prima para 60% Siniestralidad", prima60);
createRow(startRow + 6, "Tasa Técnica", tasaTecnica, "percent");
};

// =========================
// HOJA SINIESTROS
// =========================
const createSiniestrosSheet = () => {

  const data = this.data_res_siniimpa || [];

  const ws = wb.addWorksheet("Siniestros");

  ws.columns = [
    { header: "Siniestro", key: "siniestro", width: 15 },
    { header: "Rut", key: "peridnacion", width: 15 },
    { header: "Cliente", key: "nombre", width: 40 },
    { header: "Tipo Cliente", key: "sndclasific", width: 15 },
    { header: "Fecha Denuncio", key: "fecha", width: 15 },
    { header: "Mon", key: "mon1", width: 6 },
    { header: "Monto Impago Inicial", key: "montoinidocs", width: 20 },
    { header: "Saldo Impago", key: "montodocs", width: 18 },
    { header: "Cobrador Asignado", key: "cobrador", width: 20 },
    { header: "Liquidador Asignado", key: "liquidador", width: 20 },
    { header: "Estado", key: "sndestado", width: 18 },
    { header: "Origen", key: "origen", width: 22 },
    { header: "Mon", key: "mon_local", width: 6 },
    { header: "Monto Indemnizado", key: "monto_ind", width: 20 },
    { header: "Fecha Pago", key: "fec_pago", width: 15 },
    { header: "Beneficiario", key: "receptor", width: 35 }
  ];

  // Header
  const header = ws.getRow(1);

  header.font = { bold: true };

  header.alignment = {
    horizontal: "center",
    vertical: "middle",
    wrapText: true
  };

  // Formato columnas numéricas
  ws.getColumn("montoinidocs").numFmt = '0';
  ws.getColumn("montodocs").numFmt = '0';
  ws.getColumn("monto_ind").numFmt = '0';

  const estadoMap = {
    IND: "Indemnizado",
    ACT: "Activo",
    REC: "Rechazado",
    PPA: "Plan de Pago"
  };

  const estadoOrder = {
    IND: 1,
    ACT: 2, 
    REC: 3,
    PPA: 4
  };

  const formatDate = (v) => {
    if (!v) return "";

    return (
      v.substring(8, 10) + "/" +
      v.substring(5, 7) + "/" +
      v.substring(0, 4)
    );
  };

  data.sort((a, b) =>
    (estadoOrder[a.sndestado] || 999) -
    (estadoOrder[b.sndestado] || 999)
  );

  const rows = data.map(d => ({
    siniestro: d.sndsiniestro,
    peridnacion: d.peridnacion,
    nombre: d.nombre,
    sndclasific: d.sndclasific === "Nom"
      ? "Nominado"
      : "Innominado",
    fecha: formatDate(d.fec_denun),
    mon1: d.mon,
    montoinidocs: Number(d.montoinidocs || 0),
    montodocs: Number(d.montodocs || 0),
    cobrador: d.cobrador,
    liquidador: d.liquidador,
    sndestado: estadoMap[d.sndestado] || d.sndestado,
    origen: d.origen,
    mon_local: d.mon_local,
    monto_ind: Number(d.monto_ind || 0),
    fec_pago: formatDate(d.fec_pago),
    receptor: d.receptor
  }));

  ws.addRows(rows);
};
// =========================
// HOJAS GENERICAS
// =========================
const createTableSheet = (name, data) => {
  if (!data || !data.length) return;

    const ws = wb.addWorksheet(name);
    const headers = Object.keys(data[0]);

    ws.columns = headers.map(h => ({
      header: h,
      key: h,
      width: 25
    }));

    createHeader(ws);

    data.forEach(d => {
      const row = ws.addRow(d);
      applyBorder(row);
    });
  };

// =========================
// CREAR TODAS LAS HOJAS
// =========================
   createCondicionesSheet();
   createVentasSheet();
   createProduccionSheet();
   createLineasSheet();
   createSiniestralidadSheet();
   createTasaTecnicaSheet();
   createSiniestrosSheet();

// =========================
// EXPORTAR
// =========================
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Planilla Renovaciones.xlsx");
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

  selecciona_contratante(p_codcontratante, p_nomcontratante, p_idnacional){
    this.datosFormulario.contratante = p_codcontratante;
    this.datosFormulario.IdNacionAse = p_idnacional;
    this.datosFormulario.NombreAseg = p_nomcontratante
    this.modalContratante = false;

  },    
        
  pre_insercion() {
      this.$Progress.start(); 
      this.disableGenerar = false; 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data_condiciones = [];
      this.data_ventas_antepenult = [];
      this.data_ventas_penult = [];
      this.data_ventas_ult = [];
      this.data_produccion = [];
      this.data_lineas = [];
      this.data_sinihist = [];
      this.data_sinihisttot = [];
      this.data_siniultvig = [];
      this.data_tasatecnica = [];
      this.data_res_siniimpa = [];
      this.value = null;

      this.datosFormulario.poliza = "";
      this.datosFormulario.producto = "";
      this.datosFormulario.codCorredor = "";
      this.datosFormulario.NombreCorred = "";
      this.datosFormulario.IdNacionCorred = "";
      this.datosFormulario.NombreAseg = "";
      this.datosFormulario.IdNacionAse = "";
      this.hasPoliza = false;

      return apiPlanRenovaciones
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo ='0';
          this.datosFormulario.poliza='';
          this.datosFormulario.contratante='';
          this.datosFormulario.codCorredor='';
            
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    keysMinuscula(obj) {
      // Arrays
      if (Array.isArray(obj)) {
        return obj.map(item => this.keysMinuscula(item));
      }
      // Objetos
      if (obj !== null && typeof obj === 'object') {
        const nuevoObj = {};
        Object.keys(obj).forEach(key => {
          nuevoObj[key.toLowerCase()] =
            this.keysMinuscula(obj[key]);
        });
        return nuevoObj;
      }
      // Valores primitivos
      return obj;
    },

    async generar() {
      try {

        this.$Progress.start();
        this.disableGenerar = true;

        const p_email = this.$session.get("mail");
        const p_usuario = this.$session.get("usuarioInterno");

        const p_poliza =
          this.datosFormulario.poliza === ""
            ? "0"
            : this.datosFormulario.poliza;

        const p_producto =
          this.datosFormulario.producto === ""
            ? "0"
            : this.datosFormulario.producto;
  
        console.time("api");

        const response = await apiPlanRenovaciones.recuperar(
          p_email,
          p_usuario,
          p_poliza
        );

        console.timeEnd("api");

        console.log("Respuesta API recibida");
        console.log("response.data:", response.data);

        response.data = this.keysMinuscula(response.data);
        
        this.data_condiciones = response.data.res_condiciones;
        this.data_ventas_antepenult = response.data.res_ventas_antepenult;
        this.data_ventas_penult = response.data.res_ventas_penult;
        this.data_ventas_ult = response.data.res_ventas_ult;
        this.data_produccion = response.data.res_produccion;
        this.data_lineas = response.data.res_lineas;
        this.data_sinihist = response.data.res_sinihist;
        this.data_sinihisttot = response.data.res_sinihisttot;
        this.data_siniultvig = response.data.res_siniultvig;
        this.data_tasatecnica = response.data.res_tasatecnica;
        this.data_res_siniimpa = Array.isArray(response.data.res_siniimpa)? response.data.res_siniimpa: [];

        const estado = response.data.festado.resultado.estado;
        const mensaje = response.data.festado.resultado.mensaje;

        // =========================
        // EXPORTAR
        // =========================
        console.time("excel");

        await this.exportarExcel();

        console.timeEnd("excel");

      } catch (error) {

        console.error(error);
        this.crearNotificacion1("Error de sistema","Ocurrió un error al generar el archivo Excel.","error");

      } finally {
        this.disableGenerar = false;
        this.$Progress.finish();
      }
    },
  
    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
      
      this.datosFormulario.ejecutivo == 'Todos' ? '0' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_email= this.$session.get("mail");
      var p_ejecutivo= this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo==""){
          p_ejecutivo ='0';
      }

      return apiBaseDatosResoluc
        .consulta_poliza(
          p_email, p_ejecutivo, p_poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);
          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
            this.datosFormulario.contratante  = Listapoliza[i]["marcontratante"];
            this.datosFormulario.producto     = Listapoliza[i]["marproducto"];
            this.datosFormulario.codCorredor  = Listapoliza[i]["marcorredor"];
            this.datosFormulario.NombreCorred = Listapoliza[i]["nomcorredor"];
            this.datosFormulario.vigente      = Listapoliza[i]["E"];
            this.datosFormulario.ejecutivopol = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.asistentepol   = Listapoliza[i]["asistente"]; 
            this.hasPoliza = true;
          }
          this.$Progress.finish();
          this.consulta_contratante();

        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_contratante: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_contratante = this.datosFormulario.contratante == '' ? '0': this.datosFormulario.contratante; 
      var p_email = this.$session.get("mail");
      if ((p_contratante==0) || (p_contratante=="")){
          this.mensaje= "Ingrese SR Contratante";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, p_contratante
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoContratante = response.data.res;

         for (var i = 0; i < InfoContratante.length; i++) {
            this.datosFormulario.IdNacionAse = InfoContratante[i]["peridnacion"];
            this.datosFormulario.NombreAseg  = InfoContratante[i]["pernombreimp"];
            
            this.datosFormulario.asegperdireccion  = InfoContratante[i]["perdireccion"];
            this.datosFormulario.asegperciudad  = InfoContratante[i]["perciudad"];
            this.datosFormulario.asegpercomuna  = InfoContratante[i]["percomuna"];
            this.datosFormulario.asegpernacion  = InfoContratante[i]["pernacion"];
            this.datosFormulario.asegperdirpostal  = InfoContratante[i]["perdirpostal"];
            this.datosFormulario.asegperciupostal  = InfoContratante[i]["perciupostal"];
            this.datosFormulario.asegpercompostal  = InfoContratante[i]["percompostal"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.IdNacionCorred = "";
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         response.data = this.keysMinuscula(response.data);
  
         var InfoCorredor = response.data.res;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["idnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["corredor"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    DatosContratantes: function(){
      var p_email = this.$session.get("mail");
      
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data1 = response.data.res;
            this.$Progress.finish();
         
          this.$Progress.finish();
          this.modalContratante = true;
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    buscarcorredor() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      return apiConCorredor
        .consulta_corredor(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data2 = response.data.res;
            this.modalCorredor = true;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insercion();    
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
